import React, { useState, useEffect, useRef } from 'react'
import {
  DefaultPainel,
  BaseAutoComplete,
  FileMiniature,
  AdaptativeGridContainer
} from '../../components/shared'
import { Grid, Typography, Box, Modal, LinearProgress } from '@mui/material'
import CleanModal from '../../components/shared/modals/CleanModal'
import LoadingButton from '@mui/lab/LoadingButton'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import { ValidationError } from 'yup'
import resumeSchema from './functions/validations'
import GenerateValidators from '../../services/GenerateValidators'
import { Logs, Postagens, Obras, UploadVideo } from '../../services/http'
import { useNavigate } from 'react-router-dom'
import SmallTextField from '../../components/textfield/SmallTextfield'
import { getMinDate } from './functions'
import getAutoresNomes from './functions/getAutoresNomes'
import IdentifyOS from '../../services/identifyOs'
import getUser from '../../services/http/user/getUser'
import WebcamStreamCapture from '../rWebcam/components'
import FormResumeDatePicker from './components/FormResumeDatePicker'
import ButtonVideoNotIOS from './components/ButtonVideoNotIOS'
import ButtonVideoIOS from './components/ButtonVideoIOS'
import FormResumeTextField from './components/FormResumeTextField'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  borderRadius: '6px',
  maxWidth: '360px',
  boxShadow: 24,
  p: 4
}

const dropStyle = {
  background: '#EFEFEF',
  height: '93%',
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
}

export default function Cadastro() {
  const [books, setBooks] = useState([])
  const [fileName, setFileName] = useState('')
  const [resumo, setResumo] = useState('')
  const [video, setVideo] = useState()
  const [hasFile, setHasFile] = useState(false)
  const [autor, setAutor] = useState('')
  const [npagina, setNpagina] = useState('')
  const [loading, setLoading] = useState(false)
  const [modalProgress, setModalProgress] = useState(false)
  const [progress, setProgress] = useState(0)
  const [progressText, setProgressText] = useState('')
  const [currentUser, setCurrentUser] = useState()
  const [isIOS, setIsIOS] = useState(false)
  const [captureModal, setCaptureModal] = useState(false)
  const [helpers, setHelpers] = useState({})
  const [defaultBook, setDefaultBook] = useState('')
  const inputRef = useRef()
  const [form, setForm] = useState({
    obra_id: '',
    ano_id: null,
    mes_id: null,
    conteudo_aplicado_vida: '',
    date: getMinDate()
  })
  const [videoForm, setVideoForm] = useState({})
  const navigate = useNavigate()

  const httpConfig = {
    headers: { 'Content-Type': 'application/json' }
  }

  const handleSubmit = event => {
    event.preventDefault()
  }

  const getObras = async (filter = {}) => {
    const { data } = await Obras().show({
      ...filter,
      per_page: -1,
      'includes[]': 'obraAutores.autor'
    })
    const result = data.data.map(item => ({
      id: item.id,
      titulo: item.titulo,
      obra_id: item.id,
      paginas: item.numero_pagina,
      autores: getAutoresNomes(item.obra_autores)
    }))
    return result
  }

  async function postResume() {
    setLoading(true)
    try {
      setModalProgress(true)
      checkVideo()
      const isText = checkResumo()

      if (localStorage.getItem('videoName') === null) {
        localStorage.setItem('videoName', undefined)
      }
      let videoName = ''
      const existsVideoName = localStorage.getItem('videoName')
      videoName = existsVideoName

      if (existsVideoName === 'undefined' && !isText) {
        setProgressText('Salvando video...')
        const { data } = await UploadVideo().store(videoForm, {
          ...httpConfig,
          onUploadProgress: progressEvent => {
            const progress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            )
            setProgress(progress)
          }
        })

        videoName = data.name
        localStorage.setItem('videoName', videoName)
      }

      await resumeSchema.validate(form, { abortEarly: false })

      const sendPpayload = `payload - mes: ${form.mes_id} | ano: ${
        form.ano_id
      } | resumo: ${!!form.resumo} | caracteres: ${
        form.resumo ? form.resumo.length : 0
      } | video: ${!!form.video}`
      await postLog(sendPpayload.trim())
      setProgressText('Postando resumo...')

      let dados = { ...form, video: videoName }
      if (form.resumo?.length > 0) {
        dados = { ...dados, video: undefined }
        delete dados.video
      }

      const response = await Postagens().store({ ...dados }, httpConfig)

      if (response?.status === 201 || response?.status === 200) {
        setModalProgress(false)
        Swal.fire({
          icon: 'success',
          title: 'Sucesso ao postar resumo!',
          showConfirmButton: false,
          timer: 2500
        }).then(() => {
          localStorage.removeItem('resumo')
          localStorage.removeItem('obra')
          localStorage.removeItem('conteudo')
          localStorage.removeItem('postData')
          resetForm()
          navigate(-1)
        })
      }

      const sendResponse = `response - status: ${response.status} | mes: ${
        response.data.mes_id
      } | ano: ${response.data.ano_id} | resumo: ${!!response.data
        .resumo} | video: ${!!response.data.video_path}`
      await postLog(sendResponse.trim())
      setModalProgress(false)
    } catch (e) {
      setModalProgress(false)
      if (e instanceof ValidationError) {
        const helperText = GenerateValidators(e)
        setTimeout(() => {
          setHelpers({})
        }, 2000)
        setHelpers(helperText)
      }
    }
    setLoading(false)
  }

  function resetForm() {
    delete form.resumo
    delete videoForm.video

    setForm({
      obra_id: '',
      ano_id: null,
      mes_id: null,
      conteudo_aplicado_vida: ''
    })
  }

  function checkVideo() {
    httpConfig.headers = { 'Content-Type': 'multipart/form-data' }
    return video ? setVideoForm(Object.assign(videoForm, { video })) : null
  }

  function checkResumo() {
    if (resumo !== null) {
      if (resumo.length > 0) {
        setForm(Object.assign(form, { resumo }))
        if (form.video) delete form.video
        return true
      }

      delete form.resumo
      return false
    }
  }

  useEffect(() => {
    setResumo(resumo.replace(/\s\s+/g, ' '))
  }, [resumo])

  const checkDate = () => {
    setForm(
      Object.assign(form, {
        mes_id: form.date.getMonth() + 1,
        ano_id: form.date.getFullYear()
      })
    )
  }

  async function init() {
    checkDate()
    const user = await getUser()

    setCurrentUser(user)
    const emps = await getObras({})
    setBooks(emps)
    const texto = localStorage.getItem('resumo')
    const obra = localStorage.getItem('obra')
    const conteudo = localStorage.getItem('conteudo')
    let data
    if (localStorage.getItem('postData')) {
      data = dayjs(localStorage.getItem('postData'))
    }

    if (texto) {
      Swal.fire({
        text: 'Você possui um resumo que ainda não foi postado, deseja continuar a edição?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, continuar',
        cancelButtonText: 'Não, começar outro'
      })
        .then(result => {
          if (result.isConfirmed) {
            setResumo(texto)
            if (obra) {
              setForm(
                Object.assign(form, {
                  obra_id: obra
                })
              )
              setDefaultBook(getDefaultBook(emps))
            }

            setForm(
              Object.assign(form, {
                conteudo_aplicado_vida: conteudo || undefined
              })
            )
            setForm(Object.assign(form, { date: data || undefined }))
            postLog('Selecionou recuperar resumo - Tela: Postar Resumo')
          } else {
            postLog('Selecionou não recuperar resumo - Tela: Postar Resumo')

            localStorage.removeItem('resumo')
            localStorage.removeItem('obra')
            localStorage.removeItem('conteudo')
            localStorage.removeItem('postData')
          }
          checkDate()
        })
        .catch(e => {
          console.log(e)
          postLog('Problema ao recuperar resumo - Tela: Postar Resumo')
        })
    }
  }

  let logTimeout = ''
  useEffect(() => {
    init()
    const result = IdentifyOS()
    setIsIOS(result)
    clearTimeout(logTimeout)
    logTimeout = setTimeout(
      () => postLog('Entrou na tela: Postar Resumo'),
      4000
    )
  }, [])

  const removeFile = () => {
    postLog('Removeu o vídeo - Tela: Postar Resumo')
    setHasFile(false)
    setFileName('')
    setVideo(null)
  }

  const SelectVideo = event => {
    try {
      const file = event.target.files[0]
      const size = file.size / 1024 / 1024

      if (size > 200.0) {
        toast.error(
          `Falha ao carregar video. Tamanho máximo suportado: 200MB! Vídeo atual: ${Math.round(
            size
          )}MB`
        )
        postLog(
          'Selecionou um vídeo maior que tamanho suportado (IOS) - Tela: Postar Resumo'
        )

        return 0
      }
      setFileName(`${file.name} - ${Math.round(size)}MB`)
      setHasFile(true)
      setVideo(file)
      if (localStorage.getItem('videoName')) {
        localStorage.removeItem('videoName')
      }
      postLog('Selecionou um vídeo com sucesso (IOS) - Tela: Postar Resumo')
    } catch (e) {
      setFileName('')
      setHasFile(false)
      toast.error('Não foi possível carregar o arquivo!')
      postLog('Teve um erro ao selecionar vídeo (IOS) - Tela: Postar Resumo')
    }
  }

  const postLog = async message => {
    await Logs().store({ acoes: message })
  }

  const getDefaultBook = emps => {
    const livro_id = parseInt(localStorage.getItem('obra'))
    if (livro_id) {
      if (typeof livro_id === 'number') {
        return emps.find(item => {
          return parseInt(item.obra_id) === livro_id
        })
      }
    }
  }

  const GravaVideo = video => {
    try {
      const size = Math.round(video.size / 1024 / 1024)

      if (size > 200.0) {
        toast.error(
          `Falha ao carregar video. Tamanho máximo suportado: 200MB! Vídeo atual: ${Math.round(
            size
          )}MB`
        )
        postLog(
          'Gravou um vídeo maior que o tamanho máximo suportado (Android) - Tela: Postar Resumo'
        )
        return 0
      }
      setFileName(`${video.name} - ${size}MB`)
      setHasFile(true)
      setVideo(video)

      if (localStorage.getItem('videoName')) {
        localStorage.removeItem('videoName')
      }
      postLog('Gravou um vídeo com suceso (Android) - Tela: Postar Resumo')
    } catch (e) {
      setFileName('')
      setHasFile(false)
      toast.error('Não foi possível carregar o arquivo!')
      postLog('Teve um erro ao gravar vídeo (Android) - Tela: Postar Resumo')
    }
  }

  function fieldLivroChange(event) {
    if (event?.obra_id !== undefined) {
      postLog(
        `Selecionou o livro: ${event?.titulo} - id: ${event?.obra_id} - Tela: Postar Resumo`
      )
      setAutor(event.autores)
      setNpagina(event.paginas)
      localStorage.setItem('obra', event?.obra_id)
    }
    setForm({ ...form, obra_id: event?.obra_id })
  }

  function fieldDataChange(value) {
    postLog(
      `Mudou período para ${value?.$M + 1}/${value?.$y} - Tela: Postar Resumo`
    )
    localStorage.setItem('postData', value)
    setForm({
      ...form,
      date: value,
      ano_id: value?.$y,
      mes_id: value?.$M + 1
    })
  }

  function fieldConteudoChange({ target }) {
    setForm({
      ...form,
      conteudo_aplicado_vida: target.value
    })
    if (target.value === '') {
      localStorage.removeItem('conteudo')
    } else {
      localStorage.setItem('conteudo', target.value)
    }
  }

  function fieldResumoChange(e) {
    setResumo(e.target.value)
    if (e.target.value === '') {
      localStorage.removeItem('resumo')
    } else {
      localStorage.setItem('resumo', e.target.value)
    }
  }

  return (
    <DefaultPainel sx={{ margin: '4vh auto 0 auto' }}>
      <CleanModal
        title="Captura de vídeo"
        sx={{ width: { xs: '100vw', md: '30vw' } }}
        status={captureModal}
        onClose={() => setCaptureModal(false)}
      >
        <>
          <WebcamStreamCapture
            userName={currentUser?.name}
            onCaptureEnd={video => {
              setCaptureModal(false)
              GravaVideo(video)
            }}
          />
        </>
      </CleanModal>
      <Modal open={modalProgress}>
        <Box sx={style}>
          <Typography sx={{ mb: 1 }}>
            {progressText} {' ' + progress + '%'}
          </Typography>
          <LinearProgress variant="determinate" value={progress} />
        </Box>
      </Modal>
      <form
        style={{ height: 'max-content' }}
        aria-label="a dense table"
        onSubmit={handleSubmit}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            p: 0,
            mb: 0
          }}
        >
          <Typography variant="h5"> Postar Resumo </Typography>
        </Box>
        <AdaptativeGridContainer
          sx={{ justifyContent: 'space-between' }}
          rowSpacing={2}
        >
          <>
            <Grid item xs={12} md={12}>
              <BaseAutoComplete
                defaultValue={defaultBook}
                list={books}
                listLabel={'titulo'}
                inputProps={{ label: 'Livro', ...helpers.obra_id }}
                Input={SmallTextField}
                onChange={fieldLivroChange}
              />
            </Grid>
            <Grid item xs={12} md={1.9}>
              <SmallTextField
                label="Número de Páginas"
                disabled
                value={npagina}
              />
            </Grid>
            <Grid item xs={12} md={6.9}>
              <SmallTextField label="Autor(es)" disabled value={autor} />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormResumeDatePicker
                value={form.date}
                onChange={fieldDataChange}
                inputProps={{ ...helpers.mes_id }}
              />
            </Grid>

            <Grid item xs={12}>
              <SmallTextField
                value={form.conteudo_aplicado_vida}
                label="Quais conteúdos deste livro podem ser aplicados de imediato em sua vida?"
                onChange={fieldConteudoChange}
                inputProps={{ maxLength: '256' }}
                {...helpers.conteudo_aplicado_vida}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>

        <Grid container spacing={3} sx={{ mt: 0 }}>
          <Grid item xs={12} md={6}>
            <FormResumeTextField
              resumo={resumo}
              video={video}
              onChange={fieldResumoChange}
              {...helpers.resumo}
            />

            <Typography>
              Caracteres:{' '}
              <span
                style={{
                  color:
                    resumo?.length < 900 || resumo.length > 4000
                      ? 'red'
                      : 'green'
                }}
              >
                {resumo.length} / 900
              </span>
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <input
              ref={inputRef}
              onChange={SelectVideo}
              type="file"
              style={{ display: 'none' }}
            />
            <Box sx={dropStyle}>
              <FileMiniature
                name={fileName}
                visible={hasFile}
                removeAction={() => removeFile()}
                video={video}
              />

              <ButtonVideoIOS
                hasFile={hasFile}
                resumo={resumo}
                isIOS={isIOS}
                onClick={() => {
                  inputRef.current.click()
                  postLog('Clicou no botão importar - Tela: Postar Resumo')
                }}
              />
              <ButtonVideoNotIOS
                resumo={resumo}
                hasFile={hasFile}
                isIOS={isIOS}
                onClick={() => {
                  setCaptureModal(true)
                  postLog('Clicou no botão gravar - Tela: Postar Resumo')
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <LoadingButton
              onClick={() => {
                postResume()
                postLog('Clicou no botão salvar - Tela: Postar Resumo')
              }}
              loading={loading}
              variant="contained"
            >
              {loading ? 'Salvando' : 'Salvar'}
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </DefaultPainel>
  )
}
